import { CostBasisPosition } from '@shared/services';

import { math } from '../src/app/shared/helpers/mathjs/mathjs';
import { toNumber } from './utils.helpers';

type EstimatedTotalTransferValueInput = Pick<CostBasisPosition, 'estValueOfTransfer'>;

export function getEstimatedTotalTransferValue(
  positions: EstimatedTotalTransferValueInput[],
): number {
  const total: number = positions.reduce(
    (accumulated, position) => math.add(accumulated, toNumber(position.estValueOfTransfer)),
    0,
  );
  return total;
}

type EstimatedTotalTransferValueBySharesInput = Pick<
  CostBasisPosition,
  'price' | 'estValueOfTransfer' | 'sharesToTransfer'
>;

export function getEstimatedValueOfTransferByShares<
  T extends EstimatedTotalTransferValueBySharesInput,
>(position: T): T {
  const newPosition: T = { ...position };

  newPosition.estValueOfTransfer = +math.format(
    math.multiply(toNumber(newPosition.sharesToTransfer), toNumber(newPosition.price)),
    { notation: 'fixed', precision: 2 },
  );
  return newPosition;
}
